import { Box, Inline, xcss } from '@atlaskit/primitives';
import { Text } from '@atlaskit/primitives';
// FIXME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import { getFieldType } from '@databases/fields';
import { FieldTypeIcon } from '@databases/icons/FieldTypeIcon';
import { messages } from '@databases/intl/messages';
import { SkeletonItem } from '@databases/skeleton';
import { type DatabaseField } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

export interface FieldNameProps {
  field: DatabaseField;
  showIcon?: boolean;
  isBold?: boolean;
  showJiraBadge?: boolean;
}

const ellipsisOverflowStyles = xcss({
  overflow: 'hidden',
  whiteSpace: 'pre',
  textOverflow: 'ellipsis',
});

const fieldNameStyles = xcss({
  marginLeft: 'space.050',
});

/**
 * Renders the name of a database field. If the name is empty, a placeholder is shown. Optionally, the field name
 * can be decorated with an icon indicating the field type.
 */
const FieldName: FunctionComponent<FieldNameProps> = ({
  field,
  showIcon,
  isBold,
  showJiraBadge = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Inline
      alignBlock="center"
      xcss={xcss({
        width: '100%',
      })}
    >
      {showIcon && (
        <SkeletonItem isButton>
          <FieldTypeIcon
            type={field.type}
            label={getFieldType(field.type).label}
            noTooltip
            jiraField={field.settings.jiraField}
            showJiraBadge={showJiraBadge}
          />
        </SkeletonItem>
      )}
      <SkeletonItem minWidth={80}>
        <Box xcss={[ellipsisOverflowStyles, showIcon && fieldNameStyles]}>
          {isBold ? (
            <Text weight="semibold">
              {field.name || formatMessage(messages['field.default-field-name'])}
            </Text>
          ) : (
            field.name || formatMessage(messages['field.default-field-name'])
          )}
        </Box>
      </SkeletonItem>
    </Inline>
  );
};

export default FieldName;
